import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//components
import { toast } from "react-toastify";
import { Container, Row, Tabs, Tab } from "react-bootstrap";
import { ListFilters } from "../../components/list-filters";
import { DisciplineFavorites } from "../components/discipline-favorites-list"
import { UnityFavorites } from "../components/unity-favorites-list"
import { ThemeFavorites } from "../components/theme-favorites-list"
import { ObjectFavorites } from "../components/object-favorites-list"


//services
import { removeFavorite } from "../../../../services/favorites.service"
import { useNotification } from "../../../../../hooks/useNotifications";
import UsuarioContext from "../../../../../context/userContext/context";

export const Favorites = (): JSX.Element => {
  const { t: translation } = useTranslation();

  const [key, setKey] = useState("disciplines");
  const [clickedDisciplines, setClickedDisciplines] = useState<boolean>(true);
  const [clickedUnities, setClickedUnities] = useState<boolean>(false);
  const [clickedObjects, setClickedObjects] = useState<boolean>(false);
  const [filters, setFilters] = useState({});
  const {updateNotification} = useNotification()
  const { user } = useContext(UsuarioContext);

  useEffect(() => { 
    updateNotification({ quantity: 0})
  }, [])

  const handleFilters = (event?: any) => {
    setFilters({ ...event, 'page': 1 });
  }

  const handleRemoveFavorite = (id: number, type: string) => {
    removeFavorite(id).then(() => {
      switch (type) {
        case "Discipline":
          setClickedDisciplines(false)
          setClickedDisciplines(true)
          break

        case "Item":
          setClickedUnities(false)
          setClickedUnities(true)
          break

        case "Media":
          setClickedObjects(false)
          setClickedObjects(true)
          break
      }

      toast.success('Material removido com sucesso!', {
              position: "bottom-center",
            })
    }).catch((err: any) => {
      toast.error('Ocorreu um erro ao remover este material.')
    })
  }

  return (
    <Container fluid>
      <h3 className="title-materials">{translation('components.menu.favorites')}</h3>
      <hr/>
      <Row className="mb-2">
        <ListFilters handleFilter={handleFilters}></ListFilters>
      </Row>
      <div id="tabs-materials">
        <Tabs
          className="tabs mb-3"
          activeKey={key}
          onSelect={(k: any) => {
            if (k === 'disciplines') {
              setClickedDisciplines(true);
              setClickedUnities(false);
              setClickedObjects(false);
            }
            if (k === 'unities') {
              setClickedDisciplines(false);
              setClickedUnities(true);
              setClickedObjects(false);
            }
            if (k === 'objects') {
              setClickedDisciplines(false);
              setClickedUnities(false);
              setClickedObjects(true);
            }
            setKey(k)
          }}
        >
          <Tab eventKey="disciplines" title="Disciplinas">
            {
              clickedDisciplines && 
              <DisciplineFavorites isAuth={!!user.token} removeFavorite={handleRemoveFavorite} listFilter={filters}/>
            }
          </Tab>
          <Tab eventKey="unities" title="Unidades">
            {
              clickedUnities && 
              <UnityFavorites isAuth={!!user.token} removeFavorite={handleRemoveFavorite} listFilter={filters}/>
            }
          </Tab>
          <Tab eventKey="objects" title="Objetos">
            {
              clickedObjects && 
              <ObjectFavorites isAuth={!!user.token} removeFavorite={handleRemoveFavorite} listFilter={ clickedObjects ? filters: null}/>
            }
          </Tab>
        </Tabs>
      </div>
    </Container>
  )
}
